import React, { useState } from 'react';
import Sidebar from '../../Component/MainDashboard/Sidebar';
import MainDashboardPage from '../../Component/MainDashboard/MainDashboardPage';
import DashboardStyle from "./Dashboard.module.css";

const Dasboard = () => {
    const [hamburgerMenu, sethamburgerMenu] = useState("in-active");

    return (
        <div className={DashboardStyle.dashboardCont}>
            <div className={DashboardStyle.dashboardContSidebar}>
                <Sidebar hamburgerMenu={hamburgerMenu} sethamburgerMenu={sethamburgerMenu} />
            </div>
            <div className={DashboardStyle.dashboardContMain}>
                <MainDashboardPage sethamburgerMenu={sethamburgerMenu} />
            </div>
        </div>
    )
}

export default Dasboard
